import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token && !loading) {
      navigate("/login");
    }
  }, [token, loading, navigate]);

  if (loading) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  return children || <Outlet />;
}
